import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=de0a9024&"
import script from "./Wizard.vue?vue&type=script&lang=ts&"
export * from "./Wizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports